import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router";
import { useNavigate } from "react-router-dom";

/* 
  SmartThingsPro > iframe 화면
 */
const SmartThingsPro = () => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  return (
    <div
      className="pa30"
      style={{
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div
        ref={containerRef}
        className={`iframe-wrapper`}
        style={{
          position: "relative",
          width: "100%",
          height: "100%",
          minHeight: "calc(100vh - 125px)",
          overflow: "hidden",
        }}
      >
        <iframe
          src="https://smartthingspro.ai/"
          ref={iframeRef}
          width="100%"
          height="100%"
          style={{
            border: "none",
          }}
          title="SmartThings Pro"
          loading="lazy"
          allow="accelerometer; autoplay; camera; clipboard-read; clipboard-write; encrypted-media; fullscreen; geolocation; gyroscope; microphone; picture-in-picture; web-share"
          sandbox="allow-same-origin allow-scripts allow-forms allow-top-navigation allow-popups allow-popups-to-escape-sandbox"
        />
      </div>
    </div>
  );
};
export default SmartThingsPro;
